export default __webpack_public_path__ + "bead5e72eb090aead09ddf56f1eb1776.png";